<template>
  <header>
    <section>
      <div class="col1">
        <router-link to="dashboard">
          <h3>RKO</h3>
        </router-link>
        <ul class="inline">
          <li>
            <router-link to="dashboard">Dashboard</router-link>
          </li>
          <li>
            <router-link to="settings">Settings</router-link>
          </li>
          <li>
            <a @click="logout">Logout</a>
          </li>
        </ul>
      </div>
    </section>
  </header>
</template>

<script>
import Firebase from "firebase/app";
import "firebase/auth";

export default {
  methods: {
    logout() {
      Firebase.auth()
        .signOut()
        .then(() => {
          this.$store.dispatch("cleardata");
          this.$router.push("/login");
        })
        .catch(err => {
          // eslint-disable-next-line no-console
          console.log(err);
        });
    }
  }
};
</script>
